import qs from 'query-string';
import { apiEndpoint } from '../../config';
import { queryAdmin } from '../../graphql-client';

export type FetchPreviewLinkParams = {
  projectId: string;
  siteId: string;
  routeName: string;
  contentId?: string;
};

export type CreatePreviewLinkParams = {
  token: string;
} & FetchPreviewLinkParams;

export function createPreviewLink({ projectId, siteId, routeName, contentId, token }: CreatePreviewLinkParams): string {
  return `${apiEndpoint}/project/${projectId}/ssg/${siteId}/preview?${qs.stringify({
    routeName,
    contentId,
    auth: token
  })}`;
}

const getPreviewToken = queryAdmin(`
query ($siteId: String!) {
  token: getSitePreviewToken(siteId: $siteId)
}
`);

export async function fetchPreviewLink(params: FetchPreviewLinkParams): Promise<string> {
  const { token } = await getPreviewToken({ siteId: params.siteId });
  return createPreviewLink({ ...params, token });
}
